import { distributorNoticeApi } from '@/api/distributor-notice';
import QueryParameterBuilder from '@/lib/query-parameter/QueryParameterBuilder';
import DistributorNotice from '@/entity/DistributorNotice';
import PaginationOutput from '@/helpers/PaginationOutput';
export const distributorNoticeService = {
    async getItemList(param) {
        const params = new QueryParameterBuilder()
            .addPage(param.pageNumber)
            .addSize(param.pageSize);
        const response = await distributorNoticeApi.getItemList(params.build());
        return PaginationOutput.adaptorFactory(response, DistributorNotice);
    },
    async getItem(id) {
        const response = await distributorNoticeApi.getItem(id);
        return new DistributorNotice(response.data.data);
    },
    async updateItem(serviceData) {
        const response = await distributorNoticeApi.putItem(serviceData.reqBody.id, serviceData.createReqBody());
        return response.data;
    },
    async createItem(serviceData) {
        const response = await distributorNoticeApi.postItem(serviceData.createReqBody());
        return response.data;
    },
    async deleteItem(serviceData) {
        const response = await distributorNoticeApi.deleteItem(serviceData.createReqBody());
        return response.data;
    },
};
